'use client';

import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useCentrifugo } from '@/contexts/CentrifugoContext';
import { GAME_STATS_QUERY_KEY } from '../queries/useGameStatsQuery';
import type { GameStatsResponse } from '../services/generated/Api';

export const useGameStatsSubscription = () => {
  const { subscribe, isConnected, channelPrefix } = useCentrifugo();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isConnected) return;
    const channel = channelPrefix ? `${channelPrefix}_game_stats` : 'game_stats';

    const unsubscribe = subscribe(channel, (data) => {
      queryClient.setQueryData(GAME_STATS_QUERY_KEY, data as GameStatsResponse);
    });

    return unsubscribe;
  }, [isConnected, channelPrefix, subscribe, queryClient]);
};
